import React, { useState, useEffect } from "react";
import "./Css/Header.css";
import "react-international-phone/style.css";
import phone from "../Assets/mobilePhone.svg";
import locationsssss from "../Assets/locationIcon.svg";
import mainLogo from "../Assets/mainLogo.png";
import qr from "../Assets/QR.png";
import { Modal, Button } from "react-bootstrap";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import locationbook from "../Assets/locationbook.svg";
import $ from "jquery";
import dropDown from "../Assets/downArrowBlack.svg";
import { Link as ScrollLink } from "react-scroll";
import { AiOutlineClose } from "react-icons/ai";
import {
  handleAphabetsChange,
  handleEmailChange,
  handleError,
  handleLinkClick,
  handleNumbersChange,
  make_image_from_letter,
  validateEmail,
  validateMobile,
  getDistance,
} from "../CommonJquery/CommonJquery.js";
import {
  server_post_data,
  customer_login,
  city_list,
  APL_LINK,
} from "../ServiceConnection/serviceconnection.js";
import {
  removeData,
  retrieveData,
  storeData,
} from "../LocalConnection/LocalConnection.js";
let login_flag_res = "0";
let customer_id = "0";
let customer_name = "0";
let customer_mobile_no = "0";
let customer_email = "0";
let complete_status_one = "0";
function Header() {
  const navigate = useNavigate();
  customer_id = retrieveData("customer_id");
  customer_name = retrieveData("customer_name");
  let check_custom_city = retrieveData("customer_city");
  let customer_city_add_by_location = retrieveData(
    "customer_city_add_by_location"
  );
  const customer_city =
    check_custom_city === "0" ? "Gothenburg" : check_custom_city;

  const profileShow = customer_id !== "0";
  const location = useLocation();
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [userNumber, setUserNumber] = useState("");
  const [otp, setOtp] = useState(""); // State to manage the entered OTP
  const [presentotp, setpresentotp] = useState("");
  const [isPhoneNumberValid, setisPhoneNumberValid] = useState(false);
  const [isOTPValid, setisisOTPValid] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(customer_city);
  const [cityImage, setCityImages] = useState([]);
  const [ImageLink, setImageLink] = useState("");
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  const [errorMessages, setErrorMessages] = useState({
    mobileError: "",
    otpError: "",
    nameError: "",
    emailError: "",
    checkboxError: "",
  });

  const login_section_res = async () => {
    let vaild = "0";
    let login_otp = $("#opt_user").val();
    let user_email = $("#user_email").val();
    let user_name = $("#user_name").val();
    let user_last = $("#user_last").val();
    let user_anniversary = $("#user_anniversary").val();
    let user_dob = $("#user_dob").val();

    // Clear previous errors
    setErrorMessages({
      mobileError: "",
      otpError: "",
      nameError: "",
      emailError: "",
      checkboxError: "",
    });
    if (login_flag_res === "0") {
      if (!validateMobile(userNumber)) {
        vaild = "1";
      }
    }

    if (login_flag_res === "1") {
      if (parseInt(login_otp) === "") {
        vaild = "1";
      } else if (parseInt(login_otp) !== parseInt(presentotp)) {
        vaild = "1";
      } else {
        if (complete_status_one === "0") {
          $(".otp_section").hide();
          $(".last_section").show();
          login_flag_res = "2";
          return;
        } else {
          storeData("customer_id", customer_id);
          storeData("customer_name", customer_name);
          storeData("customer_mobile_no", customer_mobile_no);
          storeData("customer_email", customer_email);
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      }
    }
    if (login_flag_res === "2") {
      // Separate checks for first name and last name
      if ($.trim(user_name) === "") {
        setErrorMessages((prev) => ({
          ...prev,
          nameError: "Please enter the first name",
        }));
        vaild = "1";
      }
      if ($.trim(user_last) === "") {
        setErrorMessages((prev) => ({
          ...prev,
          lastNameError: "Please enter the last name",
        }));
        vaild = "1";
      }

      if (user_email !== "") {
        if (!validateEmail(user_email)) {
          setErrorMessages((prev) => ({
            ...prev,
            emailError: "Enter a valid Email ID",
          }));
          vaild = "1";
          return;
        }
      }

      if (!$("#user_checkbox").prop("checked")) {
        setErrorMessages((prev) => ({
          ...prev,
          checkboxError: "Agree to the terms and conditions",
        }));
        vaild = "1";
        return;
      }
    }

    if (vaild === "0") {
      setshowLoaderAdmin(true);
      const fd = new FormData();
      fd.append("owner_moblie_no_without_zip", userNumber);
      if (parseInt(login_flag_res) > 0) {
        fd.append("click_type", "1");
      } else {
        fd.append("click_type", login_flag_res);
      }
      try {
        const date_dob = new Date(user_dob);
        const formattedDateDOB = date_dob.toISOString().split("T")[0];
        const date_anniversary = new Date(user_anniversary);
        const formattedDateanniversary = date_anniversary
          .toISOString()
          .split("T")[0];
        fd.append("owner_dob", formattedDateDOB);
        fd.append("owner_anniversary", formattedDateanniversary);
      } catch (err) {
        //err
      }

      fd.append("email_id", user_email);
      fd.append("owner_name", user_name);
      fd.append("owner_lname", user_last);

      fd.append("agree_data", "1");
      await server_post_data(customer_login, fd)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            if (Response.data.message.data_guest.length > 0) {
              setpresentotp(Response.data.message.guest_otp);
              if (
                Response.data.message.data_guest[0].guest_fname === "" ||
                Response.data.message.data_guest[0].guest_fname === null
              ) {
                complete_status_one = "0";
              } else {
                complete_status_one = "1";
              }
              customer_id = Response.data.message.data_guest[0].primary_id;
              customer_name =
                Response.data.message.data_guest[0].guest_fname +
                " " +
                Response.data.message.data_guest[0].guest_lname;
              customer_mobile_no =
                Response.data.message.data_guest[0].guest_mobile_no;
              customer_email = Response.data.message.data_guest[0].guest_email;

              if (login_flag_res === "0") {
                $(".hide_ssection_profile").hide();
                $(".otp_section").show();
                login_flag_res = "1";
              } else {
                storeData("customer_id", customer_id);
                storeData("customer_name", customer_name);
                storeData("customer_mobile_no", customer_mobile_no);
                storeData("customer_email", customer_email);
                localStorage.setItem("activeSection", "home");
                setTimeout(() => {
                  window.location.reload();
                }, 800);
              }
            }
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
        });
    } else {
      // if (login_flag_res === "0") {
      //   handleError("Enter Vaild Mobile No");
      // } else if (login_flag_res === "1") {
      //   handleError("Enter Vaild OTP");
      // } else {
      //   handleError("Enter Vaild Full name");
      // }
    }
  };

  $("#login_check_jquery").on("customEvent", function () {
    handleOpenLoginModal();
  });

  const handleCloseLoginModal = () => {
    setUserNumber("");
    setShowLoginModal(false);
  };
  const handleOpenLoginModal = () => {
    login_flag_res = "0";
    $(".hide_ssection_profile").show();
    $(".otp_section").hide();
    $(".last_section").hide();
    setShowLoginModal(true);
  };

  // location modal

  const handleCloseLocationModal = () => {
    setShowLocationModal(false);
  };
  const handleShowLocationModal = () => setShowLocationModal(true);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const detectLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          master_data_get(
            1,
            position.coords.latitude,
            position.coords.longitude
          );
        },
        (err) => {
          console.log("Error getting location: " + err.message);
        }
      );
    } else {
      console.log("Geolocation is not supported by your browser");
    }
  };

  const master_data_get = async (flag, userLat, userLon) => {
    let minDistance = Infinity;
    let nearest = null;
    // console.log(city_list);
    await server_post_data(city_list, null)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setCityImages(Response.data.message.cities);
          setImageLink(Response.data.message.image_link);
          if (
            userLat !== 0 &&
            customer_city_add_by_location === "0" &&
            flag === 1
          ) {
            Response.data.message.cities.forEach((city) => {
              const distance = getDistance(
                userLat,
                userLon,
                city.lat,
                city.lng
              );

              if (distance < minDistance) {
                minDistance = distance;
                nearest = { ...city, distance };
              }
            });
            storeData("customer_city", nearest.city);
            storeData("customer_city_add_by_location", nearest.city);
            storeData("customer_city_lat", userLat);
            storeData("customer_city_long", userLon);
            setSelectedLocation(nearest.city);
            handleCloseLocationModal();
            setTimeout(() => {
              var event = new CustomEvent("customEvent");
              document.getElementById("reload_page_data").dispatchEvent(event);
            }, 500);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    master_data_get(0, 0, 0);
    detectLocation();
  }, []);

  const handleLocationChange = (selectedOptioncity, selectedOptioncountry) => {
    storeData("customer_city", selectedOptioncity);
    storeData("customer_country", selectedOptioncountry);
    storeData("customer_city_add_by_location", selectedOptioncity);
    setSelectedLocation(selectedOptioncity);
    handleCloseLocationModal();
    setTimeout(() => {
      // var event = new CustomEvent("customEvent");
      // document.getElementById("reload_page_data").dispatchEvent(event);
      window.location.reload();
    }, 400);
  };
  const [isScrolled, setIsScrolled] = useState(false);
  const isStickyHeaderActive = location.pathname === "/patnerwithus";

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {location.pathname !== "/registerMyVenue" && (
        <>
          {location.pathname !== "/patnerwithus" && (
            <div className="upper_header_wrapper">
              <div className="container-lg">
                {location.pathname !== "/onBoarding" && !isMobile && (
                  <div className="upper_header_container">
                    <Link onClick={() => handleLinkClick("/patnerwithus")}>
                      List My Restaurant
                    </Link>
                    <Link onClick={() => handleLinkClick("/getHelp")}>
                      Get help
                    </Link>
                    {profileShow && (
                      <Link
                        onClick={() => {
                          removeData();
                          localStorage.setItem("activeSection", "home");
                        }}
                      >
                        Logout
                      </Link>
                    )}
                    {/* <p>EN</p> */}
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
      <nav
        className={`navbar  navbar-expand-lg bg-body-tertiary ${
          isStickyHeaderActive ? "stickyHeaderOther" : "stickyHeader"
        } ${isScrolled ? "scrolled" : ""}`}
      >
        <div className="container-lg">
          <Link
            className="navbar-brand WebSHowonly"
            onClick={() => handleLinkClick("/")}
          >
            <img src={mainLogo} alt="mainLogo" width={150} />
          </Link>
          <div className="mobileLocationSHow">
            {!profileShow ? (
              <Link
                className="navbar-brand"
                onClick={() => handleLinkClick("/")}
              >
                <img src={mainLogo} alt="mainLogo" width={150} />
              </Link>
            ) : location.pathname !== "/onBoarding" ? (
              <div
                className="locationDropDown"
                onClick={handleShowLocationModal}
              >
                <img src={locationsssss} alt="location" />
                <label>
                  {selectedLocation} <img src={dropDown} alt="dropDown" />
                </label>
              </div>
            ) : null}
          </div>

          <div>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            {profileShow && (
              <Link
                onClick={() => handleLinkClick("/profile")}
                id="image_from_letter"
                className="d-lg-none"
              >
                <img
                  src={make_image_from_letter(customer_name)}
                  onError={(e) => {
                    e.target.src = mainLogo;
                  }}
                  alt={customer_name}
                />
              </Link>
            )}
          </div>
          <div className="collapse navbar-collapse" id="navbarScroll">
            <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll ToggleMobileLocationBar">
              <li className="nav-item">
                {location.pathname !== "/onBoarding" && (
                  <div
                    className="locationDropDown"
                    onClick={() => handleShowLocationModal()}
                  >
                    <img src={locationsssss} alt="location" />{" "}
                    <label>
                      {" "}
                      {selectedLocation} <img src={dropDown} alt="dropDown" />
                    </label>
                  </div>
                )}
              </li>
            </ul>
            {!profileShow && (
              <li className="nav-item  Notlogin ">
                {location.pathname !== "/onBoarding" && (
                  <div
                    className="locationDropDown"
                    onClick={() => handleShowLocationModal()}
                  >
                    <img src={locationsssss} alt="location" />{" "}
                    <label>
                      {" "}
                      {selectedLocation} <img src={dropDown} alt="dropDown" />
                    </label>
                  </div>
                )}
              </li>
            )}
            <form className="d-flex mobile_wrapper_header" role="search">
              <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll">
                <li className="nav-item dropdown">
                  {location.pathname !== "/patnerwithus" && (
                    <div className="mobile_phone_container">
                      {location.pathname !== "/onBoarding" && (
                        <div
                          className="nav-link dropdown-toggle"
                          onClick={() => handleOpenModal()}
                        >
                          <img src={phone} alt=" phone" /> MOBILE
                        </div>
                      )}
                    </div>
                  )}

                  {isStickyHeaderActive && (
                    <ScrollLink
                      to="getHlp"
                      smooth={true}
                      duration={500}
                      className="getHelpClssPtnerPAge"
                    >
                      Get help
                    </ScrollLink>
                  )}
                </li>
                <li>
                  {location.pathname !== "/onBoarding" && isMobile && (
                    <div className="upper_header_container_mobile">
                      {" "}
                      <Link onClick={() => handleLinkClick("/patnerwithus")}>
                        List My Restaurant
                      </Link>
                      <Link onClick={() => handleLinkClick("/getHelp")}>
                        Get help
                      </Link>
                      {profileShow && (
                        <Link
                          onClick={() => {
                            removeData();
                          }}
                        >
                          Logout
                        </Link>
                      )}
                      {/* <p>EN</p> */}
                    </div>
                  )}
                </li>
                <li>
                  {!profileShow && (
                    <Link
                      className="loginButtonMobile"
                      style={{
                        textDecoration: "none",
                        alignItems: "center",
                        width: "fitContent",
                      }}
                      onClick={() => handleOpenLoginModal()}
                    >
                      <p>Login</p>
                    </Link>
                  )}
                </li>
                <li className="nav-item"></li>
              </ul>
              {!profileShow && (
                <Link
                  className="loginButton"
                  style={{
                    textDecoration: "none",
                    alignItems: "center",
                    width: "fitContent",
                  }}
                  onClick={() => handleOpenLoginModal()}
                >
                  <p>Login</p>
                </Link>
              )}
              {profileShow && (
                <Link
                  onClick={() => handleLinkClick("/profile")}
                  id="image_from_letter"
                  className="d-none d-lg-flex"
                >
                  <img
                    src={make_image_from_letter(customer_name)}
                    onError={(e) => {
                      e.target.src = mainLogo; // Provide the path to your fallback image
                    }}
                    alt={customer_name}
                  />
                </Link>
              )}
            </form>
          </div>
        </div>
      </nav>
      <Modal
        className="login_modal modal-md"
        centered
        show={showLoginModal}
        onHide={handleCloseLoginModal}
        backdrop="static"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="phoneLoginModal_body">
          <div className="hide_ssection_profile">
            <h6>Enter your Phone Number</h6>
            <p>You will receive a text message to verify your account.</p>
            <PhoneInput
              id="phone"
              name="phone"
              placeholder="Phone Number"
              className="mt-2"
              defaultCountry="in"
              value={userNumber}
              onChange={(phone) => {
                setUserNumber(phone);
                setisPhoneNumberValid(phone.length >= 13);
              }}
              regions={["asia"]}
              onlyCountries={["in"]}
            />
            <Button
              className="PhoneloginButton mt-4 width100per"
              onClick={() => login_section_res()}
              type="button"
              style={{
                backgroundColor: !isPhoneNumberValid ? "grey" : "",
                borderColor: !isPhoneNumberValid ? "grey" : "",
                cursor: !isPhoneNumberValid ? "not-allowed" : "pointer",
              }}
              disabled={!isPhoneNumberValid}
            >
              Continue
            </Button>
          </div>
          <div className="otp_section">
            <h6>Enter the OTP</h6>
            <p>
              Please enter the OTP sent to{" "}
              <span
                className="verificationNum"
                style={{ cursor: "pointer" }}
                onClick={() => handleOpenLoginModal()}
              >
                {userNumber}
              </span>{" "}
              your phone.
            </p>
            <input
              type="text"
              id="opt_user"
              name="opt_user"
              placeholder="Enter verification code"
              className="mt-2 form-control border0"
              onInput={handleNumbersChange}
              maxLength={4}
              value={otp}
              onChange={(e) => {
                setOtp(e.target.value);
                setisisOTPValid(
                  parseInt(e.target.value) === parseInt(presentotp)
                );
              }}
            />
            <Button
              className="PhoneloginButton mt-4 width100per"
              onClick={() => login_section_res()}
              type="button"
              style={{
                backgroundColor: !isOTPValid ? "grey" : "",
                borderColor: !isOTPValid ? "grey" : "",
                cursor: !isOTPValid ? "not-allowed" : "pointer",
              }}
              disabled={!isOTPValid}
            >
              Continue
            </Button>
          </div>
          <div className="last_section">
            <h4>Welcome to Dfoodo </h4>
            <p>Create your account and quickly make a reservation </p>
            <form className="userRegistration_form">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="user_name"
                  name="user_name"
                  placeholder="First Name"
                  maxLength={50}
                  onInput={handleAphabetsChange}
                />
                <span className="error-span ERRORMSGG">
                  {errorMessages.nameError}
                </span>
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  id="user_last"
                  name="user_last"
                  className="form-control"
                  placeholder="Last Name"
                  maxLength={50}
                  onInput={handleAphabetsChange}
                />
                <span className="error-span ERRORMSGG">
                  {errorMessages.lastNameError}
                </span>
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  id="user_anniversary"
                  name="user_anniversary"
                  className="form-control"
                  placeholder="Anniversary"
                  max={new Date().toISOString().split("T")[0]}
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) =>
                    (e.target.type = e.target.value ? "date" : "text")
                  }
                  maxLength={50}
                />
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  id="user_dob"
                  name="user_dob"
                  className="form-control"
                  placeholder="Date of Birth"
                  max={new Date("2020-01-01").toISOString().split("T")[0]}
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) =>
                    (e.target.type = e.target.value ? "date" : "text")
                  }
                  maxLength={50}
                />
              </div>

              <input
                type="text"
                id="user_email"
                name="user_email"
                className="form-control"
                placeholder="Email ID"
                maxLength={100}
                onInput={handleEmailChange}
              />
              <span className="error-span ERRORMSGG">
                {errorMessages.emailError}
              </span>
              <div className="mb-3 dfoodoterms_agreement ">
                <input
                  type="checkbox"
                  id="user_checkbox"
                  name="user_checkbox"
                  value="0"
                  className="wifth_chckbox"
                />
                <p>
                  I agree to Dfoodo{" "}
                  <span
                    style={{
                      display: "inline-block",
                      color: "var(--primary-color)",
                      backgroundColor: "transparent",
                      padding: "0",
                      cursor: "pointer",
                    }}
                    to="termsOfUse"
                    onClick={() => navigate("/termsOfUse")}
                  >
                    Terms & Conditions
                  </span>{" "}
                  and{" "}
                  <span
                    style={{
                      color: "var(--primary-color)",
                      backgroundColor: "transparent",
                      padding: "0",
                      cursor: "pointer",
                    }}
                    to="privacyPolicy"
                    onClick={() => navigate("/privacyPolicy")}
                  >
                    Privacy Policy
                  </span>
                </p>
              </div>
              <span className="error-span ERRORMSGG">
                {errorMessages.checkboxError}
              </span>
              <Button
                className="PhoneloginButton mt-4 width100per"
                onClick={() => login_section_res()}
                type="button"
                style={{
                  cursor: "pointer",
                }}
              >
                Complete Profile
              </Button>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      <div id="login_check_jquery"></div>
      <div id="reload_page_data"></div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="success_modal_reg modal-md"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="phoneApp_modal_register_my_venue ">
            <h3>
              Find the best restaurants around you using{" "}
              <span style={{ color: "var(--primary-color)" }}>Dfoodo App!</span>
            </h3>
            <p>Download Dfoodo app by scanning the QR code</p>
            <img src={qr} alt="altqr" />
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showLocationModal}
        onHide={handleCloseLocationModal}
        className="LocationModdlll"
        size="lg"
        backdrop="static"
      >
        <Modal.Header>
          <div
            className="location_wrapper_headerModal"
            onClick={() => detectLocation()}
          >
            <img src={locationbook} alt="locationbook" />
            <h6>Detect my Location</h6>
          </div>
          <div className="closeModllIcnn" onClick={handleCloseLocationModal}>
            {" "}
            <AiOutlineClose className="cloSeiccnn" />{" "}
          </div>
        </Modal.Header>
        <div className="horiZonllLine"></div>
        <Modal.Body>
          <div className="SelctdCity">
            {selectedLocation && (
              <p className="location_modal_text">
                Selected City:{" "}
                <span style={{ color: "var(--primary-color)" }}>
                  {selectedLocation}
                </span>
              </p>
            )}
          </div>
          <div className="location_city_imgs">
            {cityImage &&
              cityImage.map((value, idx) => (
                <div
                  className={`{
                    selectedLocation === value.city ? "active" : ""
                  }`}
                  key={idx}
                >
                  <Link
                    className="locationImg"
                    onClick={() => {
                      handleLocationChange(value.city, value.country);
                    }}
                  >
                    <img
                      className="ShowLocationImg"
                      src={`${APL_LINK + ImageLink + value.image_name}`}
                      alt={value.city}
                    />
                    <p
                      className={`citySelecttt ${
                        selectedLocation === value.city ? "active" : ""
                      }`}
                    >
                      {value.city}
                    </p>
                  </Link>
                </div>
              ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Header;
